import React, { Component, cloneElement } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import {
  Avatar,
  CircularProgress,
  RaisedButton,
} from 'material-ui';
import moment from 'moment';
import injectSheet from 'react-jss';
import{
  openDialog,
} from '../__storeFiles__/actions';

class RouterContainer extends Component {
  openSignUp = () => this.props.openDialog({
    type: 'signup',
    viewAs: 'Supplier',
    country: this.props.country,
    signupEmail: this.props.email,
    companyName: this.props.to.name || this.props.email,
    preconfirmed: true,
  });
  openLogin = () => this.props.openDialog({ type: 'login', loginEmail: this.props.email, viewAs: 'Supplier' });
  render() {
    const {
      loading,
      from,
      startDate,
      endDate,
      classes,
      children,
    } = this.props;
    if (loading) return <CircularProgress/>;
    return (
      <div
        className={classes.container}
      >
        {/* <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
          <RaisedButton
            style={{ marginLeft: '1em' }}
            secondary
            label="Log In"
            onClick={this.openLogin}
          />
          <RaisedButton
            primary
            label="Sign Up"
            onClick={this.openSignUp}
          />
        </div> */}
        <div style={{ marginTop: '1em' }}>
          {
            from.avatar
              ? (
                <Avatar
                  src={from.avatar}
                  size={60}
                />
              ) : (
                <Avatar
                  size={60}
                >
                  {R.head(from.name)}
                </Avatar>
              )
          }
        </div>
        <div style={{ marginTop: '1em', color: 'rgba(0, 0, 0, 0.87)', fontSize: '18px' }}>
          {from.name}
        </div>
        <div style={{ marginTop: '8px', color: 'rgba(0, 0, 0, 0.87)', fontSize: '16px' }}>
          {moment.utc(new Date(startDate)).format('DD MMM YYYY')} - {moment.utc(new Date(endDate)).format('DD MMM YYYY')}
        </div>
        {cloneElement(children, { openSignUp: this.openSignUp })}
        <div className={classes.footer}>
          <div className={classes.powerby}>
            powered by &nbsp;
            <img src={require('../../../../www/images/tourconnect-logo.svg')} style={{ width: '120px' }} />
          </div>
          <div className={classes.footerText}>
            Make your products easy to sell · Track activities on your rates · Send rates to all of your partners
          </div>
          <a className={classes.terms} href="http://www.tourconnect.com/terms-of-service/" target="_blank">Terms & Conditions</a>
        </div>
      </div>
    );
  }
}

const mapState = ({ assetsLandingReducer }) => ({
  ...assetsLandingReducer.request,
  loading: assetsLandingReducer.requestLoading,
  country: assetsLandingReducer.country,
  email: assetsLandingReducer.email,
});

const styles = {
  container: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2em',
    height: '100%',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  footer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '4em auto',
  },
  powerby: {
    display: 'flex',
    alignItems: 'center',
  },
  footerText: {
    margin: '8px auto',
  },
  terms: {
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.54)',
    textDecoration: 'underline',
  },
};

const mapAction = ({
  openDialog,
});

export default connect(mapState, mapAction)(injectSheet(styles)(RouterContainer));



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/request/router-container.jsx